<template>
<code>
&lt;html><br>
&lt;head><br>
&lt;script src="https://swarm.video/swarm.js">&lt;/script><br>
&lt;script type="text/javascript" src="//cdn.jsdelivr.net/npm/clappr@latest/dist/clappr.min.js">&lt;/script><br>
&lt;script src="//cdn.jsdelivr.net/npm/clappr@latest/dist/clappr.min.js">s&lt;/script><br>
&lt;/head><br>
&lt;body><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;div id="player"> &lt;/div><br>
&lt;/body><br>
&lt;script><br>
let engine = new p2pml.hlsjs.Engine({segments: {swarmId: "CustomSwarmId"},loader: {httpUseRanges:false, WaitForTracker: true, WaitForTrackerCounter:4500}}); <br>
player = new Clappr.Player({<br>
&nbsp;&nbsp;&nbsp;&nbsp;source:'https://wowza.peer5.com/live/smil:bbb_abr.smil/playlist.m3u8',<br>
&nbsp;&nbsp;&nbsp;&nbsp;mimeType: 'application/x-mpegURL',<br>
&nbsp;&nbsp;&nbsp;&nbsp;parentId: '#player',<br>                                
&nbsp;&nbsp;&nbsp;&nbsp;playback: {<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;hlsjsConfig:
{<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;liveSyncDurationCount: 7,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;loader: engine.createLoaderClass()}<br>
&nbsp;&nbsp;&nbsp;&nbsp;}<br>
});<br>
p2pml.hlsjs.initClapprPlayer(player);<br>
&lt;/script><br>
&lt;/html><br>      
</code>
</template>

<script>
export default {
  name: "clappr",
 
  
};
</script>
